export default __webpack_public_path__ + "static/media/colombia.8e779efe.png";